module.exports = __webpack_public_path__ + "static/media/1_A1_21.47b29bfe.png";